import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

import { ContentItemPlusWebinarWidget } from "scmp-app/components/content/content-item-render/variants/plus-webinar-widget";

import Background from "./webinar-widget-background.png";

export const Container = styled.div`
  inset-block-start: 20px;

  inline-size: 100%;
  padding: 20px;

  border-radius: 8px;

  background-image: url(${Background.src});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;

export const Title = styled.div`
  margin-block-end: 16px;

  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 100%;
  text-transform: uppercase;
`;

export const Item = styled.div``;

export const ItemsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  ${Item} {
    &:not(:last-child) {
      padding-block-end: 20px;
      border-block-end: 1px solid #ffca0580;
    }
  }
`;

export const StyledContentItemPlusWebinarWidget = styled(ContentItemPlusWebinarWidget)``;
